import { BibliographicResource } from '®shared/bibliographic-resource';

export interface ResourceMetadata {
  title: string;
  description: string;
}

export type ResourceMetadataResult = ResourceMetadata[] | null;

export type ResourceFormatter = (
  resource: BibliographicResource,
) => ResourceMetadata | null;

export const formatArray = (
  title: string,
  arr: string[] | null | undefined,
  separator = ', ',
): ResourceMetadata | null => {
  if (arr && arr.length) {
    return {
      title,
      description: arr.join(separator),
    };
  }

  return null;
};

export const formatString = (
  title: string,
  value?: string,
): ResourceMetadata | null => {
  if (value) {
    return {
      title,
      description: value,
    };
  }

  return null;
};

export const i18n = {
  authors: $localize`:@@item-metadata-authors:Authors`,
  court: $localize`:@@item-metadata-court:Court`,
  dates: $localize`:@@item-metadata-dates:Published date`,
  doi: $localize`:@@item-metadata-doi:DOI`,
  edition: $localize`:@@item-metadata-edition:Edition`,
  editorNames: $localize`:@@item-metadata-editors:Editors`,
  eissns: $localize`:@@item-metadata-eissn:EISSN`,
  format: $localize`:@@item-metadata-format:Format`,
  identifier: $localize`:@@item-metadata-identifier:Identifier`,
  isbns: $localize`:@@item-metadata-isbn:ISBN`,
  issns: $localize`:@@item-metadata-issn:ISSN`,
  issue: $localize`:@@item-metadata-issue:Issue`,
  location: $localize`:@@item-metadata-location:Location`,
  number: $localize`:@@item-metadata-number:Number`,
  pages: $localize`:@@item-metadata-pages:Pages`,
  places: $localize`:@@item-metadata-placeOfPublication:Pub place`,
  publisher: $localize`:@@item-metadata-publisher:Publisher`,
  series: $localize`:@@item-metadata-serier:Series`,
  volume: $localize`:@@item-metadata-volume:Volume`,
  title: $localize`:@@item-metadata-title:Title`,
};
